import { Empty } from "antd";

function PDFPage6Table4(props: any) {
    return (
        <>
            <table className="table table-sm table-bordered cu-table-border table-striped cu-fs-10">
                <thead>
                    <tr className="">
                        <th colSpan={8}>
                            {props.TranslateString('Business spaces')}
                        </th>
                    </tr>
                    <tr className="cu-bg-green  ">
                        <th className="text-right text-nowrap fw-600">{props.TranslateString('Total number of business spaces')}</th>
                        <th className="text-right text-nowrap fw-600">{props.TranslateString('Total m2')}</th>
                        <th className="text-right text-nowrap fw-600 text-nowrap" style={{minWidth:'110px'}}>{props.TranslateString('e/m2 average')}</th>
                        <th className="text-right fw-600">{props.TranslateString('estimated value, average')}</th>
                        <th className="text-right fw-600">{props.TranslateString('estimated value, lower quartile')}</th>
                        <th className="text-right fw-600">{props.TranslateString('estimated value, upper quartile')}</th>
                        {/* <th className="text-right fw-600">{props.TranslateString('Number of sales')}</th> */}
                        <th className="text-right fw-600">{props.TranslateString('Estimation basis')}</th>
                    </tr>
                </thead>
                <tbody className="bg-light">
                    {props?.data ? 
                        <tr className='text-left'>
                            <td className="text-right">{props?.data?.business_space_amt}</td>
                            <td className="text-right">{props?.data?.surface_area}</td>
                            <td className="text-right">{props?.data?.avg_price}</td>
                            <td className="text-right">{props?.data?.indicative_price}</td>
                            <td className="text-right">{props?.data?.quartile_25}</td>
                            <td className="text-right">{props?.data?.quartile_75}</td>
                            {/* <td className="text-right">{props?.data?.sale_no}</td> */}
                            <td className="text-right">{props?.data?.estimation}</td>
                        </tr>

                        : <tr><td colSpan={8}><Empty description={props.TranslateString('Empty')}/></td></tr>}
                </tbody>
            </table>
        </>
    );
}

export default PDFPage6Table4;